import React, { useMemo } from 'react';
import { createVisibleDays, formatDate, getAttendanceStatus } from '../reportUtils';

const WEEKDAYS = ['일', '월', '화', '수', '목', '금', '토'];
const CALENDAR_WEEKDAYS = [1, 2, 3, 4, 5, 6, 0];
const getWeekendClass = (day) => {
  if (day === 0) return 'is-sunday';
  if (day === 6) return 'is-saturday';
  return '';
};

const AttendanceCalendar = ({ mode, anchorDate, rows }) => {
  const rowByDate = useMemo(() => new Map(rows.map((row) => [row.lessonDate, row])), [rows]);
  const days = createVisibleDays(mode, anchorDate);
  const anchorMonth = anchorDate.getMonth();

  return (
    <section className={`report-panel attendance-calendar attendance-calendar--${mode}`}>
      <div className="report-panel__heading">
        <h2>출석 현황</h2>
        <div className="attendance-calendar__legend">
          <span><i className="present" />출석</span><span><i className="late" />지각</span>
          <span><i className="absent" />결석</span><span><i className="none" />수업 없음</span>
        </div>
      </div>
      {mode === 'month' && (
        <div className="attendance-calendar__weekdays">
          {CALENDAR_WEEKDAYS.map((day) => (
            <span key={day} className={getWeekendClass(day)}>{WEEKDAYS[day]}</span>
          ))}
        </div>
      )}
      <div className="attendance-calendar__grid">
        {days.map((date) => {
          const dateKey = formatDate(date);
          const row = rowByDate.get(dateKey);
          const status = getAttendanceStatus(row);
          const outsideMonth = mode === 'month' && date.getMonth() !== anchorMonth;
          return (
            <article key={dateKey}
              className={`attendance-day is-${status.key} ${getWeekendClass(date.getDay())} ${outsideMonth ? 'is-outside' : ''}`}
              title={row?.jindo || status.label}>
              <span className="attendance-day__weekday">{WEEKDAYS[date.getDay()]}</span>
              <strong>{date.getDate()}</strong><i aria-hidden="true" /><small>{status.label}</small>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default AttendanceCalendar;
